import { useApiData } from "./useApiData";

export function useCompanyInfo() {
  const { data } = useApiData("/company_info.php");
  return { companyName: data?.success ? data.name : null };
}
